<template>
  <div class="scroll-y relative">
    <common-evaluation-type
      :single="single"
      v-show="show && resultList.length"
      :pop-props="popProps"
      :result-list="resultList"
      @change="handlerEvaluation"
      @close="closeEvaluation"
      :selected-student-list="selectedStudentList"
      @right-click="
        $router.push({
          path: '/classcard/moral/batchStudent',
          query: {
            selectedStudentList: JSON.stringify(selectedStudentList),
            single: single
          }
        })
      "
    >
      <template v-slot:empty="slotProps">
        <common-empty v-if="slotProps.info.empty"></common-empty>
      </template>
    </common-evaluation-type>
    <common-empty
      v-show="!resultList.length"
      type="2"
      content="暂无考评组"
    ></common-empty>
  </div>
</template>

<script>
import mixin from '@/mixin'
import commonEvaluationType from './commonEvaluationType'
import commonEmpty from './commonEmpty'
import { getCombineRole } from '@/utils/comUtils'
import { mcToast, mcShowPreloader, mcHidePreloader } from '@/utils/mcSdkUtils'
import API from '@/api'
export default {
  name: 'moralEvaluationBatchStudent',
  mixins: [mixin],
  components: {
    commonEmpty,
    commonEvaluationType
  },
  props: {
    single: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    selectedStudentList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      WORD_COMMENT_ID: '3',
      studentIdList: [],
      tabType: '',
      wordComment: '',
      resultList: [],
      evaluationType: 0,
      moralEduEvaluationItemId: '',
      remark: '',
      imgList: [],
      popProps: {
        open: true,
        maskClosable: false,
        zIndex: 9999,
        position: 'bottom'
      }
    }
  },
  created() {
    this.resetData()
    this.fetchEvaluationType()
  },
  deactivated() {},
  methods: {
    changeHandler(e) {
      this.$refs.uploadImg.handlerToUploadImg(e)
    },
    resetData() {
      this.studentIdList = this.$store.state.cacheObject || []
      this.tabType = ''
      this.wordComment = ''
      this.resultList = []
      this.evaluationType = 0
      this.moralEduEvaluationItemId = ''
    },
    handlerEvaluation({ type, value, volumflag, evaluationType }) {
      this.tabType = type
      this.moralEduEvaluationItemId = ''
      this.wordComment = ''
      this.evaluationType = evaluationType
      if (volumflag) {
        this.wordComment = value
      } else {
        this.moralEduEvaluationItemId = value
      }
      this.handlerSave()
      setTimeout(() => {
        this.popProps.open = false
      }, 400)
    },
    closeEvaluation() {
      this.popProps.open = false
      this.$emit('close')
    },
    async handlerSave() {
      this.$emit('evaluate')

      if (!(this.wordComment || this.moralEduEvaluationItemId)) {
        return mcToast({ msg: '请选择考评项' })
      }
      mcShowPreloader()
      try {
        const isVocal = this.tabType === this.WORD_COMMENT_ID
        let picUrls = []
        if (this.imgList.length && !isVocal) {
          picUrls = await this.fetchUploadImgs(this.imgList)
        }
        let _param = {
          operUserRoleTypes: `${getCombineRole(
            this.currentRole,
            'moralEvaluation'
          )}`,
          campusId: this.campusId,
          moralEduEvaluationGroupId: this.tabType,
          evaluationType: this.evaluationType,
          studentDingIds: this.studentIdList,
          remark: !isVocal ? this.remark : '',
          picUrls
        }

        if (this.wordComment) {
          _param.wordComment = this.wordComment
        } else {
          _param.moralEduEvaluationItemId = this.moralEduEvaluationItemId
        }
        const res = await API.teacherBatchEvaluationStudent(_param)
        if ((res || {}).result) {
          mcHidePreloader()
          return mcToast({ msg: res.message })
        }
        mcToast({ msg: '考评成功' })
      } catch (err) {
        mcHidePreloader()
      }
    },
    async fetchUploadImgs(imgList) {
      let _total = imgList.length
      let _completedCount = 0
      let _urlImgs = []
      return new Promise(async (resolve, reject) => {
        if (!_total) {
          resolve(_urlImgs)
          return false
        }
        for (let index = 0; index < imgList.length; index++) {
          const img = imgList[index]
          // 修改的时候如果带进来有照片会导致此处出错 因为上传组件里面使用的是浅拷贝 因为此处需要判断是否包含文件 如果不包含文件就认为是后台上传的图片在执行上传操作
          if (!img.blob) {
            _urlImgs.push(img.previewImgURL)
            _completedCount++
            index === imgList.length - 1 && resolve(_urlImgs)
            continue
          }
          let _formData = new window.FormData()
          _formData.append('file', img.blob)
          _formData.append('name', 'image')
          _formData.append('imageType', 0)

          await API.uploadTemporaryFile(_formData)
            .then(res => {
              _urlImgs.push(res)
            })
            .catch(err => {
              reject(err)
            })
            .finally(() => {
              _completedCount++
              if (_completedCount === _total) {
                resolve(_urlImgs)
              }
            })
        }
      })
    },
    // 获取考评类型
    fetchEvaluationType() {
      mcShowPreloader()
      return new Promise((resolve, reject) => {
        let _param = {
          operUserRoleTypes: `${getCombineRole(
            this.currentRole,
            'moralEvaluation'
          )}`,
          campusId: this.campusId
        }
        if (this.curIsClassTeacher || this.curIsMeTeacher) {
          /* eslint-disable */
          _param.teacherRoleType =
            this.curIsClassTeacher && this.curIsMeTeacher
              ? 0
              : this.curIsClassTeacher
              ? 1
              : 2
        }
        API.getEvaluateListTeacherMoralEduEvaluationGroup(_param)
          .then(res => {
            this.resultList = res || []
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            mcHidePreloader()
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-wrap {
  width: 100%;
  height: 100%;
  .upload-box {
    position: relative;
    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      cursor: pointer;
      opacity: 0;
    }
  }
  .upload-wrap {
    padding: 13px 16px 16px;
    background: #fff;
    position: relative;
    .iconfont {
      font-size: 16px;
      position: absolute;
      top: 16px;
      left: 56px;
      transform: translate(50%, -50%);
      color: rgba(17, 31, 44, 0.4);
    }
    .upload-list {
      width: 56px;
      height: 56px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .upload-preivew {
    :deep(.img-upload) {
      display: none;
    }
    :deep(.img-item) {
      margin-top: 16px;
    }
  }
}
</style>
